module.exports = "/_next/static/images/PersonalizationEngine@2x-05cb804dcf0595bc037ff3d7bafe5cfb.webp";